import { gql } from '@apollo/client';
import AgreementFragment from './fragments/agreement.fragment';

export default gql`
  query getAccordedAgreements {
    getAccordedAgreements {
      ...AgreementFragment
    }
  }
  ${AgreementFragment}
`;
